import React from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { PageLoader } from "../../assets/images";

function InputMultiple({
  bg,
  border,
  shadow,
  soal_pilihan,
  soal_jawaban,
  name,
  handleChange,
  handleChangeFile,
  soalFile,
  handleDeleteFile,
  loadingUpload,
  preview,
  kerjakan,
  dipilih,
}) {
  const { t } = useTranslation();
  const fileRef = useRef(null);
  return (
    <div className="col-12 col-md">
      <div
        className={`iq-card ${bg} border ${border}`}
        style={{ borderRadius: "0.75rem", boxShadow: `0 8px 0 0 #${shadow}` }}
      >
        <div className="iq-card-body d-flex justify-content-between">
          {!preview && !kerjakan ? (
            <div className="send-panel">
              {soalFile && (
                <button
                  onClick={() => handleDeleteFile(name)}
                  className="btn iq-bg-primary border-0 p-0 text-primary"
                >
                  <i className="ri-delete-bin-fill m-0"></i>
                </button>
              )}
              <label
                className=" iq-bg-primary rounded"
                htmlFor={"file-" + name}
              >
                <input
                  ref={fileRef}
                  type="file"
                  id={"file-" + name}
                  className="d-none"
                  accept="image/png, image/jpg, image/jpeg"
                  onChange={(e) => handleChangeFile(name, e)}
                  disabled={loadingUpload === name || loadingUpload}
                />{" "}
                <button
                  onClick={() => fileRef.current?.click()}
                  className="btn border-0 p-0 text-primary"
                  disabled={loadingUpload === name || loadingUpload}
                >
                  {loadingUpload === name ? (
                    <img src={PageLoader} alt="loader" height={20} width={20} />
                  ) : (
                    <i className="ri-image-fill m-0"></i>
                  )}
                </button>
              </label>
            </div>
          ) : (
            <div className="flex-1"></div>
          )}
          <div className="checkbox d-inline-block">
            <input
              className="rabsen"
              style={{ width: 25 }}
              type="checkbox"
              name="soal_jawaban"
              id="soal_jawaban"
              checked={kerjakan ? dipilih : soal_jawaban}
              onChange={() =>
                handleChange({ target: { name: "soal_jawaban", value: name } })
              }
              readOnly={preview}
            />
          </div>
        </div>
        <div className="iq-card-body pt-0">
          {soalFile && (
            <img
              src={soalFile}
              alt="Soal File"
              className="img-fluid rounded mb-2"
            />
          )}
          {kerjakan || preview ? (
            <p className="m-0 font-size-20 text-center">{soal_pilihan}</p>
          ) : (
            <textarea
              className="placeholder-white bg-transparent text-white form-control text-center font-size-18 line-height pt-5 input-soal"
              style={{ border: "2px solid rgba(255, 0, 0, 0)", height: "auto" }}
              rows="6"
              name={name}
              value={soal_pilihan}
              onChange={handleChange}
              placeholder={t("isi_jawab_disini")}
              disabled={preview || kerjakan}
            ></textarea>
          )}
        </div>
      </div>
    </div>
  );
}

export default InputMultiple;
